/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { ICardMarket, ICardMarketInterface } from "../ICardMarket";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "buyer",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "MarketBuy",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
    ],
    name: "MarketRemove",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "acceptedToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "MarketSet",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "referrer",
        type: "address",
      },
    ],
    name: "buyFromMarket",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getAllMarkets",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "tokenId",
            type: "bytes32",
          },
          {
            internalType: "uint256",
            name: "minimumAmount",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "acceptedToken",
            type: "address",
          },
        ],
        internalType: "struct ICardMarket.CardMarketState[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
    ],
    name: "marketFor",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "tokenId",
            type: "bytes32",
          },
          {
            internalType: "uint256",
            name: "minimumAmount",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "acceptedToken",
            type: "address",
          },
        ],
        internalType: "struct ICardMarket.CardMarketState",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
    ],
    name: "removeMarketFor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "acceptedToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "minimumAmount",
        type: "uint256",
      },
    ],
    name: "setMarketFor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class ICardMarket__factory {
  static readonly abi = _abi;
  static createInterface(): ICardMarketInterface {
    return new utils.Interface(_abi) as ICardMarketInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ICardMarket {
    return new Contract(address, _abi, signerOrProvider) as ICardMarket;
  }
}
